import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as AddPictureIcon } from '@work4all/assets/icons/add_picture.svg';

import {
  BaseActionButton,
  IBaseActionButtonProps,
} from '../../../base-action-button/BaseActionButton';

export const UploadImageButton: React.FC<
  Pick<IBaseActionButtonProps, 'onClick'>
> = (props) => {
  const { t } = useTranslation();

  return (
    <BaseActionButton
      onClick={props.onClick}
      title={t('INPUTS.ADD_PICTURE')}
      icon={<AddPictureIcon />}
    />
  );
};
